import { render, staticRenderFns } from "./DesktopHamburgerMenu.vue?vue&type=template&id=12c886b3&scoped=true&"
import script from "./DesktopHamburgerMenu.vue?vue&type=script&lang=js&"
export * from "./DesktopHamburgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./DesktopHamburgerMenu.vue?vue&type=style&index=0&id=12c886b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c886b3",
  null
  
)

export default component.exports